import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardTitle,
  CardBody,
  CardActions,
} from "@progress/kendo-react-layout";

export default function EnrollNewForm(props) {
  const history = useHistory();
  const enrollClick = (card) => {
    history.push({
      pathname: `/plan`,
      state: { plan: card, electionDates: props.electionDates },
    });
  };

  return (
    <>
      {props.enrollCoverage.length === 0 && <div className="cardNoRecord">There are no available plans to display.<br></br></div>}
      <div className="card-list-wrap">
        {props.enrollCoverage.map((card, index) => {
          return (
            <div key={index} className="card-items">
              <Card>
                <div>
                  <CardBody>
                    <CardTitle>{card.insuranceID >= 0 ? (
                        <div className="text-ellipsis description-block">
                          {card.insurancePlanTypeDescription} ID #
                          {card.insuranceID}
                        </div>
                      ) : (
                        <span className="text-ellipsis description-block">{card.insurancePlanTypeDescription}</span>
                      )}
                      </CardTitle>      
                      <div className="description-details"><div dangerouslySetInnerHTML={{__html: card.PlanTypeDetails}}/></div>             
                  </CardBody>
                  <CardActions>
                    <Button
                      themeColor="primary"
                      fillMode="flat"
                      onClick={() => enrollClick(card)}
                    >
                      Enroll
                    </Button>
                  </CardActions>
                </div>
              </Card>
            </div>
          );
        })}
      </div>
    </>
  );
}
